import axios from "axios";
import { getLang } from "@/util/config";
import vulcan from '@huobi-lib/vulcan-js-sdk';
const TIME_OUT = 300000;

const instance = axios.create({
  baseURL: "/-/x",
  timeout: TIME_OUT,
  headers: {
    "Accept-Language": getLang().toLowerCase() === 'zh-tc' ? 'zh-hk' : getLang(),
    // "vToken": vToken,
  },
});
instance.interceptors.request.use(
  function (config) {
    // Do something before request is sent
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);
instance.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    if (response && response.data) {
      if (Object.keys(response.data).includes("code")) {
        if (response.data.code === 512) {
          // window.location.href = `/en-us/login?backUrl=${encodeURIComponent(window.location.href.replace(window.location.origin, ''))}`
        }
      }
    }
    return response;
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error);
  }
);

async function initializeAxios() {
  const { vToken } = await vulcan.vulcanVtoken();
  instance.defaults.headers["vToken"] = vToken;
  return instance;
}
initializeAxios().catch(console.error);


export default instance;
